module.exports = __webpack_public_path__ + "static/media/user-crown.da16ee10.svg";